<ng-container *transloco="let t; prefix: 'fuelChanges.validationModal'">
<div class="validation-modal-main">
  <div class="wrapper-mainbox">
    <div class="top-title">
      <h2>{{fuelChangeDetail.driver}}</h2>
      <button (click)="closeModal()">
        <img src="./assets/images-fuel/closeModalBtnIcon.svg" alt="icon-close" />
      </button>
    </div>
  </div>

  <div class="validation-modalbody">
    <div class="row">
      <div class="col-lg-7">
        <div class="validation-modalleft">
          <div class="select-buttonwrap">
            <div class="common-drop-down">
              <button class="btn btn-secondary" type="button" id="actionDropdown"
                data-bs-toggle="dropdown" aria-expanded="false">
                {{ (selectedAction ? getValidationLabel(selectedAction) : t('action')) }}<i><img src="./assets/images-fuel/select-arrow-icon.svg"
                    alt="arrow-icon" /></i>
              </button>
              <ul class="dropdown-menu" aria-labelledby="actionDropdown">
                <li><a class="dropdown-item" (click)="selectAction('Valid')">{{ t('options.valid') }}</a></li>
                <li><a class="dropdown-item" (click)="selectAction('Invalid')">{{ t('options.invalid') }}</a></li>
              </ul>
            </div>

            <div class="common-drop-down">
              <button class="btn btn-secondary" [ngClass]="{'has-discrepancy': discrepancyReason}"
                type="button" id="reasonDropdown" data-bs-toggle="dropdown" aria-expanded="false">
                {{ (selectedReason ? getValidationLabel(selectedReason) : t('reason')) }}<i><img src="./assets/images-fuel/select-arrow-icon.svg"
                    alt="arrow-icon" /></i>
              </button>
              <ul class="dropdown-menu" aria-labelledby="reasonDropdown">
                <li><a class="dropdown-item" (click)="selectReason('Lawful Removal')">{{ t('options.lawfulRemoval') }}</a>
                </li>
                <li><a class="dropdown-item" (click)="selectReason('Tank Sharing')">{{ t('options.tankSharing') }}</a></li>
                <li><a class="dropdown-item" (click)="selectReason('Contamination')">{{ t('options.contamination') }}</a></li>
                <li><a class="dropdown-item" (click)="selectReason('Pilfering')">{{ t('options.pilfering') }}</a></li>
                <li><a class="dropdown-item" (click)="selectReason('Other')">{{ t('options.other') }}</a></li>
              </ul>
              <!-- <span *ngIf="discrepancyReason" class="discrepancy-label">{{ discrepancyReason }}</span> -->
              <span *ngIf="selectedReason === 'Other'" class="reason">
                <input 
                  type="text" 
                  class="form-control custom-reason"
                  [placeholder]="t('customReasonPlaceholder')" 
                  (keydown.enter)="onEnterPressed($event)">
              </span>
            </div>

            <!-- <div class="common-drop-down export-drop-down">
                            <button class="btn btn-secondary dropdown-toggle" type="button" id="dropdown-button"
                                data-bs-toggle="dropdown" aria-expanded="false">
                                Export <i><img src="./assets/images-fuel/downloadIcon.svg" alt="export-icon" /></i>
                            </button>
                            <ul class="dropdown-menu" aria-labelledby="dropdown-button">
                                <li><a class="dropdown-item">Export as pdf</a></li>
                                <li><a class="dropdown-item">Export as csv</a></li>
                                <li><a class="dropdown-item">Send via email</a></li>
                            </ul>
                        </div> -->

            <!-- <button class="common-button" [disabled]="isLoading" (click)="autoValidateDecrease()">{{
              isLoading ? 'Validating...' :
              'Auto Validate' }}</button> -->
            <button class="common-button common-button-background" [disabled]="!isSubmitEnabled || isLoading || selectedReason === 'Other'"
              (click)="submitDecreaseInvestigation()">{{
              isSubmitting ? t('submitting') : t('submit')}}</button>
          </div>

          <div class="validation-boxwrap">
            <div class="row">
              <div class="col-lg-6 col-md-6 col-sm-12">
                <div class="validation-box validation-minus active">
                  <h4>{{ t('fuelChange') }} <img src="./assets/images-fuel/infoIcon.svg" alt="" [ngbTooltip]="t('fuelChangeTooltip')"></h4>
                  <div class="litre">
                    <img src="./assets/images-fuel/fuelPumpIcon.svg" alt="">
                    <p><strong>{{ '-' + fuelChangeDetail.amount + 'ℓ' }}</strong></p>
                  </div>
                  <div class="validation-box-details">
                    <h5>{{ t('timestamp') }}</h5>
                    <p>{{ fuelChangeDetail.timestamp | date:'dd/MM/yyyy HH:mm' }}</p>
                  </div>
                  <div class="validation-box-details">
                    <h5>{{ t('location') }}</h5>
                    <p>
                      <strong class="pointer" (click)="onLocationClick(fuelChangeDetail.lat, fuelChangeDetail.lng, -fuelChangeDetail.amount)">
                        {{ fuelChangeDetail.location }}
                      </strong>
                    </p>
                  </div>
                </div>
              </div>

              <div class="col-lg-6 col-md-6 col-sm-12">
                <div class="validation-box">
                  <h4>{{ t('currentFuel') }} <img src="./assets/images-fuel/infoIcon.svg" alt=""  [ngbTooltip]="t('currentFuelTooltip')"></h4>
                  <span *ngIf="!isCurrentFuelLevelLoading && assetFuelLevel">
                    <div class="litre">
                      <img src="./assets/images-fuel/fuelPumpIcon.svg" alt="">
                      <p><strong>{{ assetFuelLevel?.fuelLevel + 'ℓ' }}</strong></p>
                    </div>
                    <div class="validation-box-details">
                      <h5>{{ t('timestamp') }}</h5>
                      <p>{{ assetFuelLevel?.timeSent | date:'dd/MM/yyyy HH:mm' }}</p>
                    </div>
                    <div class="validation-box-details">
                      <h5>{{ t('location') }}</h5>
                      <p>
                        <strong class="pointer"
                          (click)="onLocationClick(assetFuelLevel?.latitude, assetFuelLevel?.longitude, assetFuelLevel?.fuelLevel)">
                          {{ assetFuelLevel?.locationText }}
                        </strong>
                      </p>
                    </div>
                  </span>
                  <span *ngIf="!isCurrentFuelLevelLoading && !assetFuelLevel">
                    <div class="empty-state-container">
                      <app-empty-state class="empty-msg" [message]="'No current fuel level reading at the moment'"></app-empty-state>
                      <div class="support-msg">{{ t('contactSupport') }}</div>
                    </div>
                  </span>
                  <div class="loading">
                    <span *ngIf="isCurrentFuelLevelLoading" class="spinner-border x"></span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="table-group">
            <div class="validation-table">
              <!-- <app-common-table [modalType]="'eventTableOne'"></app-common-table> -->
              <div class="main-table event-table">
                <table class="table">
                  <thead>
                    <tr>
                      <th>{{ t('eventType') }}</th>
                      <th>{{ t('fuelValue') }}</th>
                      <th>{{ t('location') }}</th>
                      <th>{{ t('timeStamp') }}</th>
                    </tr>
                  </thead>

                  <tbody *ngIf="isFuelSummaryLoading" class="spinner-container">
                    <tr>
                      <td colspan="4">
                        <span class="spinner-border"></span>
                      </td>
                    </tr>
                  </tbody>

                  <tbody *ngIf="!isFuelSummaryLoading && !assetFuelLevelSummary?.eventBefore" class="spinner-container">
                    <tr>
                      <td colspan="4">
                        <app-empty-state class="event" [message]="t('eventNotAvailable')"></app-empty-state>                      
                      </td>
                    </tr>
                  </tbody>

                  <tbody *ngIf="!isFuelSummaryLoading">
                    <tr  *ngIf="assetFuelLevelSummary?.eventBefore">
                      <td><strong>{{ assetFuelLevelSummary?.localizedEventBefore || assetFuelLevelSummary?.eventBefore }}</strong></td>
                      <td>{{ assetFuelLevelSummary?.fuelLevelBefore }}</td>
                      <td>
                        <div class="location"
                          (click)="onLocationClick(assetFuelLevelSummary?.latitudeBefore, assetFuelLevelSummary?.longitudeBefore, assetFuelLevelSummary?.fuelLevelBefore)">
                          {{ assetFuelLevelSummary?.locationTextBefore }}
                        </div>
                      </td>
                      <td>{{ (assetFuelLevelSummary?.timeSentBefore | date:'dd/MM/yyyy HH:mm' ) }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <div class="net-changes">
              <div class="accordion" id="accordionExample">
                <div class="accordion-item">
                  <div class="accordion-header" id="headingOne">
                    <div class="net-changes-tab accordion-button" [ngClass]="{'has-data': hasAssetFuelChanges}" type="button" data-bs-toggle="collapse"
                      data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                      <div class="net-changes-tab-text d-flex align-items-center justify-content-between">
                        <h3>{{ t('totalNetChange') }} <img src="./assets/images-fuel/infoIcon.svg" alt="" [ngbTooltip]="t('totalNetChangeTooltip')"></h3>
                        <p *ngIf="!isFuelChangesLoading" class="value"
                          [ngClass]="{'increase': totalNetFuelChange > 0,  'decrease': totalNetFuelChange < 0}">{{
                          totalNetFuelChange }}
                          ℓ</p>
                        <span *ngIf="isFuelChangesLoading"
                          class="spinner-container d-flex align-items-center justify-content-center spinner-border"></span>
                        <button>{{ t('view') }}</button>
                      </div>
                    </div>
                  </div>

                  <div id="collapseOne" class="accordion-collapse collapse show" aria-labelledby="headingOne"
                    data-bs-parent="#accordionExample">
                    <div class="accordion-body">
                      <!-- <app-common-table [modalType]="'eventTableThree'"></app-common-table> -->
                      <div class="main-table event-table event-table-three">
                        <table class="table">
                          <tbody>
                            <tr *ngFor="let change of assetFuelChanges">
                              <th>{{ change.localizedEvent || change.event }}</th>
                              <td [ngClass]="{'increase': change.fuelChange > 0, 'decrease': change.fuelChange < 0}">{{
                                change.fuelChange }} ℓ</td>
                              <td>
                                <div class="location" (click)="onLocationClick(change.latitude, change.longitude, change.fuelChange)">{{
                                  change.locationText }}</div>
                              </td>
                              <td>{{ change.timeSent | date:'dd/MM/yyyy HH:mm' }}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="validation-table last-event">
              <!-- <app-common-table [modalType]="'eventTableTwo'"></app-common-table> -->
              <div class="main-table event-table">
                <table class="table">
                  <thead>
                    <tr>
                      <th>{{ t('eventType') }}</th>
                      <th>{{ t('fuelValue') }}</th>
                      <th>{{ t('location') }}</th>
                      <th>{{ t('timeStamp') }}</th>
                    </tr>
                  </thead>

                  <tbody *ngIf="isFuelSummaryLoading" class="spinner-container">
                    <tr>
                      <td colspan="4">
                        <span class="spinner-border"></span>
                      </td>
                    </tr>
                  </tbody>

                  <tbody *ngIf="!isFuelSummaryLoading && !assetFuelLevelSummary?.eventAfter" class="spinner-container">
                    <tr>
                      <td colspan="4">
                        <app-empty-state class="event" [message]="t('pendingNextEvent')"></app-empty-state>                      
                      </td>
                    </tr>
                  </tbody>

                  <tbody *ngIf="!isFuelSummaryLoading">
                    <tr *ngIf="assetFuelLevelSummary?.eventAfter">
                      <td><strong>{{ assetFuelLevelSummary?.localizedEventAfter || assetFuelLevelSummary?.eventAfter }}</strong></td>
                      <td>{{ assetFuelLevelSummary?.fuelLevelAfter }}</td>
                      <td>
                        <div class="location"
                          (click)="onLocationClick(assetFuelLevelSummary?.latitudeAfter, assetFuelLevelSummary?.longitudeAfter, assetFuelLevelSummary?.fuelLevelAfter)">
                          {{ assetFuelLevelSummary?.locationTextAfter }}
                        </div>
                      </td>
                      <td>{{ assetFuelLevelSummary?.timeSentAfter | date:'dd/MM/yyyy HH:mm' }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <!-- <div class="search-menu-lists">
                        <div class="upload-button-wrap d-flex align-items-center">
                            <div class="upload-button d-flex align-items-center justify-content-center">
                                Fuels Changes <img src="assets/images-fuel/uploadIcon.svg" alt="">
                                <input type="file">
                            </div>
                            <div class="upload-button d-flex align-items-center justify-content-center">
                                Events Report <img src="assets/images-fuel/uploadIcon.svg" alt="">
                                <input type="file">
                            </div>
                            <div class="upload-button d-flex align-items-center justify-content-center">
                                Validation Tool Report <img src="assets/images-fuel/uploadIcon.svg" alt="">
                                <input type="file">
                            </div>
                        </div>
                    </div> -->
        </div>
      </div>

      <div class="col-lg-5">
        <div class="validation-modalright">
          <app-common-map [mapCenter]="mapCenter" [mapHeight]="'100%'" [clusterRenderer]="clusterRenderer"
            [markerFactory]="markerFactory" [data]="mapData" [showDropdown]="false" 
            [mapTypeControl]="mapTypeControl" [canExpandMap]="false" [disableClustering]="true" [mapTypeId]="'satellite'">
          </app-common-map>
        </div>
      </div>
    </div>
  </div>
</div>
</ng-container>